import React from "react";
import isNumber from "lodash/isNumber";
import classNames from "classnames";
import { NoCounterpartyStatsRow } from "../../../common/contracts/counterparty.contract";
import { GridTableRow } from "../../general/Tables/GridTable/GridTable";
import { EllipsisWithTooltip } from "../../general/EllipsisWithTooltip/EllipsisWithTooltip";
import { CategoryIcon } from "../../transactions/CategoryIcon";
import { currencyFormatter } from "../../../common/helpers/currency";
import { useCounterpartyTransactionsLink } from "../../../hooks/useCounterpartyTransactionsOpener";
import { useCategoriesById } from "../../../hooks/useCategoriesById";
import styles from "./DirectoryTable.module.scss";

interface Props {
    row: NoCounterpartyStatsRow;
    showRevenue: boolean;
    showSpend: boolean;
    isLast?: boolean;
}

export const NoCounterpartyStatsItem: React.FC<Props> = ({
    row,
    showSpend,
    showRevenue,
    isLast,
}) => {
    const categoriesById = useCategoriesById();
    const category = categoriesById[row.categoryId];
    const transactionsLink = useCounterpartyTransactionsLink(null, {
        includeDateFilter: true,
        categories: [category],
    });

    return (
        <GridTableRow
            className={classNames(styles.row, {
                [styles.lastRow]: isLast,
            })}
            columnBorders
        >
            <div className={styles.categoryWithoutCounterparty}>
                <div className={styles.categories}>
                    <CategoryIcon categoryId={row.categoryId} />
                    {category && (
                        <EllipsisWithTooltip
                            fullText={category.label}
                            tooltipId={`no_counterparty_${row.categoryId}`}
                        >
                            {(ref) => (
                                <span
                                    className={styles.categoryLabel}
                                    ref={ref}
                                >
                                    {category.label}
                                </span>
                            )}
                        </EllipsisWithTooltip>
                    )}
                </div>
            </div>
            <div>
                <a
                    href={transactionsLink}
                    target="_blank"
                    className={styles.transactionsLink}
                >
                    {row.transactionsCount}
                </a>
            </div>
            {showRevenue && (
                <div className={styles.revenue}>
                    {isNumber(row.revenue)
                        ? currencyFormatter.format(row.revenue)
                        : null}
                </div>
            )}
            {showSpend && (
                <div className={styles.spend}>
                    {isNumber(row.spend)
                        ? currencyFormatter.format(row.spend)
                        : null}
                </div>
            )}
        </GridTableRow>
    );
};
